import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Button from "../../../../ui/Button";
import Progress from "../../../../ui/Progress";
import { SmallStateIcon, StateTextColor} from "../../components/StateStyles";
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru';
import InfoDrawer from "../../../../ui/InfoDrawer";
import ImageBox from "../../../../ui/InfoDrawer/components/ImageBox";
import StateBlock from "../../../../ui/InfoDrawer/components/StateBlock";
import DeviderLine from "../../../../ui/InfoDrawer/components/DeviderLine";
import TitleField from "../../../../ui/InfoDrawer/components/TitleField";
import InfoField from "../../../../ui/InfoDrawer/components/InfoField";
import CardOrganization from "../../../../ui/CardOrganization";
import {getQuizCard} from "../../store/actions";

const useStyles = makeStyles(theme => ({
  more: {
    marginTop: 24,
    marginBottom: 90,
    display: "flex",
    justifyContent: "center"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  }
}));

const formatDate = date =>
    date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const QuizDrawer = ({ open, quizId, history, hideLink,
                      getQuizCard, quizCard}) => {
  const classes = useStyles();

  React.useEffect(() => {
    if (quizId !== -1) {
      getQuizCard(quizId);
    }
  }, [quizId]);

  const onLinkClick = () => {
    history.push(`/work/app/quiz/manage/${quizId}`);
  };

  return (
    <InfoDrawer open={open}>
      {quizCard ? <>
        <ImageBox image={quizCard.logo}/>
          <TitleField title={quizCard.name}/>
          <StateBlock rightChipLabel={quizCard.statusName}
                      rightChipBackground={StateTextColor(quizCard.statusId)}
                      rightChipIcon={SmallStateIcon(quizCard.statusId, "svgIcon svgFillWhite")}/>
          <DeviderLine/>
          <InfoField name="Создан" value={quizCard.dateCreate ? formatDate(quizCard.dateCreate) : '-'}/>
          <InfoField name="Тип опроса" value={quizCard.typeName || '-'}/>

          <DeviderLine/>
          <InfoField name="Организация" display={"block"} value={
            quizCard.organization ?
              <CardOrganization
                orgName={quizCard.organization.name}
                logo={quizCard.organization.logo}
              /> : <Typography>не указана</Typography>
          }/>
          <DeviderLine/>
          <InfoField name="Ссылка для публикации"
                     display={"block"}
                     value={`https://www.copp72.ru/quiz/${quizId}`}/>

          <DeviderLine/>

          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
      </> :
        <div className={classes.progress}>
          <Progress />
        </div>}
    </InfoDrawer>
  );
};

const mapStateToProps = state => ({
  quizCard: state.manageQuiz.quizCard
});

const mapDispatchToProps = dispatch => ({
  getQuizCard: id => dispatch(getQuizCard(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(QuizDrawer));
